const devices = {
  pc: {
    value: 'pc',
    icon: 'fa-desktop',
    minWidth: '1024px',
    width: '100%',
    height: '100%',
    minHeight: '50dvh',
    prefix: 'lg',
    index: 2,
  },
  tablet: {
    value: 'tablet',
    icon: 'fa-tablet',
    minWidth: '768px',
    width: '768px',
    height: '1240px',
    minHeight: '1240px',
    prefix: 'md',
    index: 1,
  },
  mobile: {
    value: 'mobile',
    icon: 'fa-mobile',
    minWidth: '0px',
    width: '360px',
    height: '736px',
    minHeight: '736px',
    prefix: undefined,
    index: 0,
  },
}

export { devices }
